import { render } from "./ModalProfileSeller.vue?vue&type=template&id=70543540"
import script from "./ModalProfileSeller.vue?vue&type=script&lang=js"
export * from "./ModalProfileSeller.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__